import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class BreadCrumbs extends ThemeComponent {
    @Prop({default: ''}) class!: string;

}
